import React, { useEffect, useState } from "react";
import usePgiModules from "../../hooks/useModules";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import useHome from "../../hooks/useHome";
import { isVideov2 } from "../../helpers/isVideo";
import toast from "react-hot-toast";

function ModuleBlockNews({ editPgi, idProducto }) {
  const { getModulesByParams, modulesBloqueInfo, setBloqueInfo, setModulesBloqueInfo } =
    usePgiModules();
    const { getBloqueInfo } = useHome();
    
    useEffect(() => {
      getModulesByParams({ state: true, title: "Bloque_info" }).then((res) => {
        setBloqueInfo(...res);
        setModulesBloqueInfo(...res);
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [bloques, setBloques] = useState([]);
  useEffect(() => {
    const getInfoBloque = async () => {
      try {
        const { data } = await getBloqueInfo();
        setBloques(data?.allBloqueInfo);
      } catch (error) {
        toast.error('Error al obtener la informacion de los bloques')
      }
    }
    getInfoBloque();
  }, []);

  const arrayBloque = bloques?.filter(
    (bloque) => bloque.deleted !== true && bloque?.visible?.includes(idProducto)
  );

  return editPgi ? (
    <>
      {arrayBloque?.map((modulesBloqueInfo, index) => (
        <div key={index} id="bloque-noticia" className="d-flex flex-nowrap">
          <section>
            <div
              className={`card-map ${modulesBloqueInfo.alignment === "align-right"
                  ? "bloque-info-derecha"
                  : "bloque-izquierda"
                }`}
            >
              {isVideov2(modulesBloqueInfo.image_desktop[0]?.url) ? (
                <video src={modulesBloqueInfo.image_desktop[0]?.url} className="img-card-noticia zoomOut" />
              ) : (
                <picture>
                  <img
                    src={
                      modulesBloqueInfo.image_desktop ? modulesBloqueInfo.image_desktop[0]?.url : ""
                    }
                    alt={
                      modulesBloqueInfo.image_desktop
                        ? modulesBloqueInfo.image_desktop[0]?.alt
                        : modulesBloqueInfo?.title_content
                    }
                    title={modulesBloqueInfo?.title_content}
                    className="img-card-noticia"
                    loading="lazy"
                  />
                </picture>
              )}
            </div>
          </section>
          <section
            id="institucional__dondecomprar"
            className={`container display-bloque ${modulesBloqueInfo.alignment === "align-right"
                ? "bloque-izquierda"
                : "bloque-info-derecha"
              }`}
          >
            <div className="grid-bloque">
              <div className="style-donde-comprar-izquierda">
                <article className="info-card">
                  <h2>{modulesBloqueInfo.title_content}</h2>

                  <div
                    className="bloqueInfo-tiny-editor"
                    dangerouslySetInnerHTML={{
                      __html: modulesBloqueInfo.content
                    }}
                  ></div>
                  {modulesBloqueInfo?.seeMoreLink ? (
                    <div className="pt-3">
                      <a
                        className="settings_button-border button-b-primary_2 posicion-boton"
                        href={`${modulesBloqueInfo.seeMoreLink}`}
                      >
                        Ver Más <ArrowForwardOutlinedIcon />
                      </a>
                    </div>
                  ) : null}
                </article>
              </div>
            </div>
          </section>
        </div>
      ))}
    </>
  ) : (
    <>
      {arrayBloque?.map((bloqueInfo, index) => (
        <div key={index} id="bloque-noticia" className="d-flex flex-nowrap">
          <section>
            <div
              className={`card-map ${bloqueInfo.alignment === "align-right" ? "bloque-info-derecha" : "bloque-izquierda"
                } in`}
            >
              {isVideov2(bloqueInfo.image_desktop[0]?.url) ? (
                <video src={bloqueInfo.image_desktop[0]?.url} className="img-card-noticia zoomOut" />
              ) : (
                <picture>
                  <img
                    src={bloqueInfo.image_desktop ? bloqueInfo.image_desktop[0]?.url : ""}
                    alt={
                      bloqueInfo.image_desktop
                        ? bloqueInfo.image_desktop[0]?.alt
                        : bloqueInfo?.title_content
                    }
                    title={modulesBloqueInfo?.title_content}
                    className="img-card-noticia zoomOut"
                    loading="lazy"
                  />
                </picture>
              )}
            </div>{" "}
          </section>
          <section
            id="institucional__dondecomprar"
            className={`container display-bloque ${bloqueInfo.alignment === "align-right" ? "bloque-izquierda" : "bloque-info-derecha"
              } in`}
          >
            <div className="grid-bloque">
              <div className="style-donde-comprar-izquierda">
                <article className="info-card inRight">
                  <h2>{bloqueInfo.title_content}</h2>

                  <div
                    className="bloqueInfo-tiny-editor"
                    dangerouslySetInnerHTML={{ __html: bloqueInfo.content }}
                  ></div>
                  {bloqueInfo?.seeMoreLink ? (
                    <div className="pt-3">
                      <a
                        className="settings_button-border button-b-primary_2 posicion-boton"
                        href={`${bloqueInfo.seeMoreLink}`}
                      >
                        Ver Más <ArrowForwardOutlinedIcon />
                      </a>
                    </div>
                  ) : null}
                </article>
              </div>
            </div>
          </section>
        </div>
      ))}
    </>
  );
}

export default ModuleBlockNews;
